module.exports = __webpack_public_path__ + "img/logo.cbb3066f.svg";